export default "__VITE_ASSET__BFNgNWz6__"